'use strict';

/**
 * @ngdoc overview
 * @name pivoApp
 * @description
 * # pivoApp
 *
 * Main module of the application.
 */
angular
  .module('pivoApp', [
    'ngAnimate',
    'ngCookies',
    'ngResource',
    'ngRoute',
    'ngSanitize',
    'ngTouch',
    'LocalStorageModule',
    'chart.js',
    'ui.bootstrap'
  ])
  .config(['localStorageServiceProvider', function(localStorageServiceProvider){
      localStorageServiceProvider.setPrefix('ls');
  }])
  .config(["$routeProvider", function ($routeProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'views/main.html',
        controller: 'BoardCtrl'
      })
      .when('/about', {
        templateUrl: 'views/about.html',
        controller: 'AboutCtrl'
      })
      .when('/licensing', {
        templateUrl: 'views/licensing.html',
        controller: 'LicensingCtrl'
      })
      // .when('/contact', {
      //   templateUrl: 'views/contact.html',
//        controller: 'ContactCtrl'
      // })
      .otherwise({
        redirectTo: '/'
      });
  }]);

'use strict';

angular.module('pivoApp')
.factory('PivolService', ['PivotalService', function (ps) {
    var checkLicenseKey = function(license) {
        var createLicense = function(licenseType, start, end, projectId) {
            var keylength = 16;
            var secretSalt = 'ekorrnSattIGranen';

            var key = licenseType + ' ' +
                      start + ' -> ' +
                      end;

            var secret = ps.me.id + ' ' +
                         projectId + ' ' +
                         secretSalt;

            key = '[Pivoboard: ' + key + ' ' +
                  CryptoJS.SHA1(key + secret).toString().substring(0, keylength) +
                  ']';
            return key;
        };

        var pattern = /\[Pivoboard\: (demo|project|account) (....-..-..) -> (....-..-..) (\S*)\]/;
        var match;

        try {
            match = license.match(pattern);
        } catch (TypeError) {
            return false;
        }

        if (!match) {
            return false;
        }

        var licenseType = match[1];
        var start = match[2];
        var end = match[3];
        //var hash = match[4];
        var projectId = 456;
        
        //verify hash
        if (license !== createLicense(licenseType, start, end, projectId)) {
            return false;
        }

        //check time limit
        var now = Date();
        //console.log('now: ' + now + ' end: ' + end);

        if ((now < Date(start)) ||
            (now > Date(end))) {
            return false;
        }

        return true;
    };

    return {
        check: checkLicenseKey
    };
}]);


'use strict';

angular.module('pivoApp')
.factory('PivotalService', ['$http', '$timeout', function ($http, $timeout) {
    var states = {notStarted: 'not-started', inProgress: 'in-progress', checkMe: 'check-me', done: 'done'};
    var columns = [states.notStarted, states.inProgress, states.checkMe, states.done];
    var API = 'https://www.pivotaltracker.com/services/v5/';
    var sprint = {license: null,
                  stories: [],
                  members: [],
                  number: null};
    var me = {};
    var pivoboard_version = {current: null,
                             warning: false};

    // {'id':1688272,'initials':'PT','name':'Pivo Test',
    //  'email':'pivotest@unitware.se','api_token':'f958b92d1f4a4679ae4e7311b158cc89',
    //  'accounts':[{'id':777428,'name':'Unitware','admin':true,'owner':false,
    //               'IAmActive': true,
    //               'projects':[{'id':1354690, 'name':'pivotest', 'IAmActive': true, 'users':[{'id':1296520,'role':'owner','name':'Magnus Ivarsson','initials':'MI','active':true},{'id':1688272,'role':'member','name':'Pivo Test','initials':'PT','active':true}]}],
    //               'license':{'expiry':'2015-11-01',
    //                          'updated':'2015-10-01',
    //                          'state':'demo',
    //                          'balance':0,
    //                          'used_this_month':0},
    //               'contact':{'name': 'Kalle Anka', 'email': 'a@b.c', 'id':123},
    //               'settings':{'company':{'name':'Unitware Sweden AB',
    //                                      'vat':'AA123456',
    //                                      'site':'Sweden'}}}]};
    var _MS_PER_SECOND = 1000;
    var _MS_PER_HOUR = 60 * 60 * _MS_PER_SECOND;
    var _MS_PER_DAY = _MS_PER_HOUR * 24;

    var workingTasksInProgress = 0;
    var pollingMe = {interval: _MS_PER_HOUR,
                     retry_interval: 60 * _MS_PER_SECOND,
                     started: null};
    var pollingProjectVersion = {interval: 5 * _MS_PER_SECOND,
                                 retry_interval: 60 * _MS_PER_SECOND,
                                 started: null};

    var set_reload_warning_if_version_changed = function() {
        if (pivoboard_version.current === null) {
            pivoboard_version.current = me.pivoboard_version;
        } else if (pivoboard_version.current !== me.pivoboard_version) {
            pivoboard_version.warning = true;
        }
    };

    var startPollingProjectVersion = function(settings, sprintNumber, interval) {
        interval = interval || pollingProjectVersion.interval;

        if (pollingProjectVersion.started) {
            $timeout.cancel(pollingProjectVersion.started);
        }

        pollingProjectVersion.started = $timeout(function() {
            if (updateSprintLicense(settings.accountId)) {
                hasProjectUpdated(settings, sprintNumber);
            }
        },
        interval);
    };

    var startPollingMe = function(settings, interval) {
        interval = interval || pollingMe.interval;

        if (pollingMe.started) {
            $timeout.cancel(pollingMe.started);
        }

        pollingMe.started = $timeout(function() {
            getMe(settings);
        },
        interval);
    };

    var clear = function() {
        sprint.stories = [];
        angular.copy({}, me);
    };

    var logout = function() {
        var req = {
            method: 'GET',
            url: 'api/logout.php'
        };

        return $http(req)
            .error(function() {
                console.error('logout err: ' + req.url);
            });
    };

    var projectVersion = null;

    var isSuperuser = function() {
        return me.super_user;
    };

    var _getterNoProgress = function(settings, endpoint, params, api) {
        api = api || API;
        var req = {
            method: 'GET',
            url: api + endpoint,
            headers: {'X-TrackerToken': settings.apiToken},
            params: params || {}
        };

        return $http(req)
            .error(function() {
                console.error('_get err: ' + req.url);
            });
    };

    var _getter = function(settings, endpoint, params, api) {
        params = params || {};

        var decreaseWip = function() {
            workingTasksInProgress --;
        };

        workingTasksInProgress ++;

        return _getterNoProgress(settings, endpoint, params, api)
                .success(decreaseWip)
                .error(decreaseWip);
    };

    var hasProjectUpdated = function(settings, sprintNumber) {
        if (!settings.apiToken) {
        	return;
        }

        _getterNoProgress(settings, 'projects/' + settings.projectId, {fields: 'version'})
            .success( function(data) {
                var newVer = data.version;
                if (!projectVersion) {
                    projectVersion = newVer;
                }
                else if (projectVersion !== newVer) {
                    projectVersion = newVer;
                    getSprint(settings, sprintNumber);
                    return;
                }

                startPollingProjectVersion(settings, sprintNumber);
            })
            .error(function () {
                startPollingProjectVersion(settings, sprintNumber, pollingProjectVersion.retry_interval);
            });
    };

    var getMe = function(settings) {
        return _getter(settings, 'me.php', {}, 'api/')
                    .success(function(data) {
                        angular.copy(data, me);
                        set_reload_warning_if_version_changed();
                        updateUserIsActiveInProjects(me);
                        startPollingMe(settings);
                    })
                    .error(function() {
                        startPollingMe(settings, pollingMe.retry_interval);
                    });
    };

    var getMeBasicAuth = function(settings, user, passwd) {
        var api = 'api/me.php';
        var params = {username: user, password: passwd};

        workingTasksInProgress ++;
        return $http.post(api, params)
            .error(function() {
                console.error('login failure');
                workingTasksInProgress --;
            })
            .success(function(data) {
                angular.copy(data, me);
                updateUserIsActiveInProjects(me);
                settings.apiToken = angular.copy(data.api_token);  // jshint ignore:line
                workingTasksInProgress --;
                startPollingMe(settings);
            });
    };

    var updateUserIsActiveInProjects = function(me) {
        for (var accountIndex = me.accounts.length - 1; accountIndex >= 0; accountIndex--) {
            var account = me.accounts[accountIndex];
            
            account.IAmActive = false;
            for (var projectIndex = account.projects.length - 1; projectIndex >= 0; projectIndex--) {
                var project = account.projects[projectIndex];
                project.IAmActive = false;

                for (var userIndex = project.users.length - 1; userIndex >= 0; userIndex--) {
                    var user = project.users[userIndex];
                    if (user.id === me.id) {
                        project.IAmActive = user.active;
                        if (user.active) {
                            account.IAmActive = user.active;
                        }
                        continue;
                    }
                }
            }
        }
    };

    var getActiveProjectMembers = function(settings) {
        for (var accountIndex = me.accounts.length - 1; accountIndex >= 0; accountIndex--) {
            var account = me.accounts[accountIndex];
            
            if (account.id === settings.accountId) {
                for (var projectIndex = account.projects.length - 1; projectIndex >= 0; projectIndex--) {
                    var project = account.projects[projectIndex];

                    if (project.id === settings.projectId)
                    {
                        var activeUsers = [];
                        for (var userIndex = project.users.length - 1; userIndex >= 0; userIndex--) {
                            var user = project.users[userIndex];
                            if (user.active) {
                                activeUsers.push(user);
                            }
                        }
                        return activeUsers;
                    }
                }
            }
        }

        return [];
    };

    // a and b are javascript Date objects
    function dateDiffInDays(a, b) {
        // Discard the time and time-zone information.
        var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }

    function daysUntilExpiry(expiryDateString) {
        if (expiryDateString === 'not_activated' || 
            expiryDateString === 'expired') {
            return 0;
        }

        return Math.max(0, dateDiffInDays(new Date(), new Date(expiryDateString)));
    }


    var cancel_sprint = function() {
        sprint.license = null;
        sprint.stories = [];
        sprint.members = [];
        sprint.number  = null;
    };

    var updateSprintLicense = function(accountId) {
        var account;
        
        if (!accountId) {
            cancel_sprint();
            return false;
        }

        for (var i = me.accounts.length - 1; i >= 0; i--) {
            if (me.accounts[i].id === accountId) {
                account = me.accounts[i];
            }
        }

        if (!currentUserEnabledInAccount(account)) {
            cancel_sprint();
            return false;
        }

        sprint.license = account.license;
        
        if (account.license.state === 'licensed') {
            return true;
        }
        else if (account.license.state === 'demo') {
            sprint.license.daysLeft = daysUntilExpiry(account.license.expiry);
            if (sprint.license.daysLeft) {
                return true;
            }
        }
        else {
            cancel_sprint();
            return false;
        }
    };

    var update_stories = function(new_stories) {
        for (var i = new_stories.length - 1; i >= 0; i--) {
            var old_story = _find_story(new_stories[i].id);
            if (old_story) {
                new_stories[i].showstory = old_story.showstory;
                new_stories[i].tasks = angular.copy(old_story.tasks);
            }
        }

        sprint.stories = angular.copy(new_stories);
    };

    var getSprint = function(settings, sprintNumber) {
        var params = {fields: 'number,start,finish,stories(current_state,id,name,story_type)'};

        if (!updateSprintLicense(settings.accountId)) {
            return;
        }

        if (sprintNumber === 'current') {
            params.scope = 'current';
        } else {
            params.offset = sprintNumber-1;
            params.limit = 1;
        }

        return _getter(settings, 'projects/' + settings.projectId + '/iterations',params)
                    .success(function(data) {
                        sprint.members = angular.copy(getActiveProjectMembers(settings));
                        update_stories(data[0].stories);
                        sprint.number = angular.copy(data[0].number);
                        sprint.start = angular.copy(data[0].start);
                        sprint.finish = angular.copy(data[0].finish);
                        _getAllStoryTasks(settings);
                        startPollingProjectVersion(settings, sprintNumber);
                    });
    };

    var _update_story_state = function(settings, story, new_state) {
        var endpoint = 'projects/' + settings.projectId +
                       '/stories/' + story.id;

        var req = {
            method: 'PUT',
            url: API + endpoint,
            headers: {'X-TrackerToken': settings.apiToken},
            params: {current_state: new_state}
        };

        workingTasksInProgress ++;
        return $http(req)
            .success(function() {
                story.current_state = new_state;
                //temporary hack?
                projectVersion ++;
                workingTasksInProgress --;
            })
            .error(function() {
                workingTasksInProgress --;
                console.error('_update_story_state err: ' + req.url);
            });
    };


    var _find_story = function(story_id) {
        for (var i = sprint.stories.length - 1; i >= 0; i--) {
            if (sprint.stories[i].id === story_id) {
                return sprint.stories[i];
            }
        }

        // console.error('did not find story id: ' + story_id);
        return null;
    };

    var _count_columns = function(story) {
        var counters = {};
        var i;

        for (i = columns.length - 1; i >= 0; i--) {
            counters[columns[i]] = 0;
        }

        for (i = story.tasks.length - 1; i >= 0; i--) {
            counters[story.tasks[i].state]++;
        }

        return counters;
    };

    var _current_state_filter = function(current_state) {
        var valid_states = ['planned', 'unstarted', 'started', 'finished'];
        for (var i = valid_states.length - 1; i >= 0; i--) {
            if (current_state === valid_states[i]) {
                return true;
            }
        }

        return false;
    };

    var _updateStoryState = function(settings, story_id) {
        // check story state and change if neccesary, i.e tasks have moved
        var story = _find_story(story_id);
        var column_counts = _count_columns(story);
        var new_state = story.current_state;
        var num_tasks = story.tasks.length;

        if (story.story_type === 'release') {
            // releases does not have the states started nor finished
            return;
        }

        if (!_current_state_filter(story.current_state)) {
            return;
        }

        if (column_counts[states.inProgress] || column_counts[states.checkMe]) {
            new_state = 'started';
        }
        else if (column_counts[states.done] === num_tasks) {
            new_state = 'finished';
        }

        if (new_state !== story.current_state) {
            _update_story_state(settings, story, new_state);
        }
    };

    var doneTodayTimestamp = function() {
        return new Date().toISOString().substr(0, 10);
    };

    var doneTodayTag = function() {
        return '[' + doneTodayTimestamp() + ':done]';
    };

    // abcd efg (4h) -> abcd efg (4h) [1234-56-78:done]
    var cleanupDoneStateIfNeeded = function(settings, task) {
        // [1234-56-78:done] -> no change
        if (null !== task.description.match(/ \[....-..-..:done\]/)) {
            return false;
        }
        
        // [MI:in_progress] -> [1234-56-78:done]
        var tmp = task.description.replace(/ \[\w*:[\w-]*\]/, doneTodayTag());
        if (tmp !== task.description) {
            task.description = tmp;
            return true;
        }

        // abcd efg (4h) -> abcd efg (4h) [1234-56-78:done]
        task.description += ' ' + doneTodayTag();
        return false;
    };

    var _taskEstimatedHours = function(description) {
        var reg = /\((\d+)h\)/i;
        var match = reg.exec(description);
        if (match) {
            return parseInt(match[1]);
        }
        else {
            return null;
        }
    };

    var getStoryTasks = function(settings, story) {
        _getter(settings, 'projects/' + settings.projectId + '/stories/' + story.id + '/tasks')
        .success(function(data) {
            story.tasks = angular.copy(data);
            var match;

            for (var i = story.tasks.length - 1; i >= 0; i--) {
                var task = story.tasks[i];
                var taskShallBeSaved = false;
                if (task.complete) {
                    task.state = states.done;
                    taskShallBeSaved = cleanupDoneStateIfNeeded(settings, task);
                    
                    var completeAtPattern = /\[(....-..-..):done\]/;
                    match = completeAtPattern.exec(task.description);
                    if (match) {
                        task.complete_at = match[1];
                    }
                    else {
                        console.error('uups: ' + task.description);
                    }
                }
                else if (task.description.includes(states.checkMe +']')) {
                    task.state = states.checkMe;
                }
                else if (task.description.includes(states.inProgress + ']')) {
                    task.state = states.inProgress;
                }
                else {
                    task.state = states.notStarted;
                }

                task.estimatedHours = _taskEstimatedHours(task.description);

                task.owner = '';
                if (!task.complete) {
                    var ownerPattern = /\[(\w*):.*]/;
                    match = ownerPattern.exec(task.description);
                    if (match) {
                        task.owner = match[1];
                    }
                }

                task.title = task.description.replace(/\[.*\]/, '')
                              .replace(/\(\d+h\)/i, '')
                              .trim();

                if (taskShallBeSaved) {
                    putTask(settings, task);
                }
            }

            _updateBurndown();
        });
    };

    var _getAllStoryTasks = function(settings) {
        for (var i = sprint.stories.length - 1; i >= 0; i--) {
            getStoryTasks(settings, sprint.stories[i]);
        }
    };
    
    var putTask = function(settings, task, setMeAsOwnerIfApplicable) {
        setMeAsOwnerIfApplicable = setMeAsOwnerIfApplicable || false;
        var endpoint = 'projects/' + settings.projectId +
                       '/stories/' + task.story_id + // jshint ignore:line
                       '/tasks/' + task.id;

        task.description = task.title;
        if (task.estimatedHours !== null)
        {
            task.description += ' (' + task.estimatedHours + 'h)';
        }

        if (task.state === states.inProgress ||
            task.state === states.checkMe)
        {
            if (task.owner !== me.initials && setMeAsOwnerIfApplicable) {
                task.owner = me.initials;
            }
            else if (setMeAsOwnerIfApplicable) {
                task.owner = '';
            }

            task.description += ' [' + task.owner + ':' + task.state + ']';
        }
        else
        {
            task.owner = '';
        }

        if (task.state === states.done)
        {
            if (!task.complete_at) {
                task.complete_at = doneTodayTimestamp();
            }

            task.description += ' [' + task.complete_at + ':' + task.state + ']';
            task.complete = true;
        }
        else {
            task.complete = false;
        }

        var req = {
            method: 'PUT',
            url: API + endpoint,
            headers: {'X-TrackerToken': settings.apiToken},
            params: {description: task.description,
                     complete:    task.complete,
                     position:    task.position}
        };

        _updateBurndown();

        workingTasksInProgress ++;
        return $http(req)
            .success(function() {
                //temporary hack?
                projectVersion ++;
                workingTasksInProgress --;
                _updateStoryState(settings, task.story_id);
            })
            .error(function() {
                workingTasksInProgress --;
                console.error('_putTask err: ' + req.url);
            });
    };

    var column2index = function(columnName) {
        for (var i = columns.length - 1; i >= 0; i--) {
            if (columnName === columns[i]) {
                return i;
            }
        }

        console.error('column2index: could not find column name: ' + columnName);
        return -1;
    };

    var moveRight = function(settings, task) {
        var i = column2index(task.state);

        task.state = columns[i+1];

        putTask(settings, task, true);
    };

    var moveLeft = function(settings, task) {
        var i = column2index(task.state);
        task.state = columns[i-1];

        putTask(settings, task, true);
    };

    var updateTaskOwner = function(settings, task, owner) {
        if (task.state === states.inProgress ||
            task.state === states.checkMe)
        {
            task.owner = owner;
            putTask(settings, task);
        }
    };


    var saveAccount = function(settings, account) {
        console.log('saving account: ' + account.name);

        var req = {
            method: 'PUT',
            url: 'api/me.php',
            headers: {'X-TrackerToken': settings.apiToken},
            data: {account: account}
        };

        workingTasksInProgress ++;
        return $http(req)
            .success(function() {
                workingTasksInProgress --;
            })
            .error(function() {
                workingTasksInProgress --;
                console.error('saveAccount err: ' + req.url);
            });
    };

    var buyCredits = function(settings, account, numberToBuy) {
        console.log('buying credits: ' + account.name + ' ' + numberToBuy);

        var req = {
            method: 'PUT',
            url: 'api/me.php',
            headers: {'X-TrackerToken': settings.apiToken},
            data: {account: account,
                   buy_credits: {account_id:    account.id,   // jshint ignore:line
                                 customer: {id: me.id,
                                            name: me.name,
                                            email: me.email},
                                 company: account.settings.company,
                                 number_to_buy: numberToBuy}} // jshint ignore:line
        };

        workingTasksInProgress ++;
        return $http(req)
            .success(function() {
                workingTasksInProgress --;
            })
            .error(function() {
                workingTasksInProgress --;
                console.error('saveAccount err: ' + req.url);
            });
    };

    var getTransactions = function(settings, account) {
        console.log('getting transactions: ' + account.id);
        account.transactions = [];

        var req = {
            method: 'GET',
            url: 'api/transactions.php',
            headers: {'X-TrackerToken': settings.apiToken},
            params: {account_id: account.id}
        };

        return $http(req)
        .success(function(data) {
            angular.copy(data, account.transactions);
        });
    };

    var transaction_is_done = function(settings, account_id, transaction_id) {
        console.log('checking transaction: ' + account_id + ', ' + transaction_id);

        var req = {
            method: 'PUT',
            url: 'api/transaction_is_done.php',
            headers: {'X-TrackerToken': settings.apiToken},
            data: {account_id: account_id,
                   transaction_id: transaction_id}
        };

        return $http(req);
    };

    var transaction_is_cancelled = function(settings, account_id, transaction_id) {
        console.log('cancel transaction: ' + account_id + ', ' + transaction_id);

        var req = {
            method: 'DELETE',
            url: 'api/transaction_is_done.php',
            headers: {'X-TrackerToken': settings.apiToken},
            data: {account_id: account_id,
                   transaction_id: transaction_id}
        };

        return $http(req);
    };


    var activeUsersInProject = function(project) {
        var numActiveUsers = 0;

        for (var i = project.users.length - 1; i >= 0; i--) {
            if (project.users[i].active) {
                numActiveUsers ++;
            }
        }

        return numActiveUsers;
    };


    var activeUsersInAccount = function(account) {
        var numActiveUsers = 0;

        for (var i = account.projects.length - 1; i >= 0; i--) {
            numActiveUsers += activeUsersInProject(account.projects[i]);
        }

        return numActiveUsers;
    };


    var currentUserEnabledInAccount = function(account) {
        if (account && account.projects && account.projects.length) {
            for (var i = account.projects.length - 1; i >= 0; i--) {
                var project = account.projects[i];
                for (var j = project.users.length - 1; j >= 0; j--) {
                    if (project.users[j].active && project.users[j].id === me.id) {
                        return true;
                    }
                }
            }
        }

        return false;
    };

    var burndown = {
        labels: [],
        series: ['Hours'],
        data: [
            []
        ]
    };

    var _updateBurndown = function() {
        if (workingTasksInProgress ||
            undefined === sprint ||
            undefined === sprint.stories) {
            return;
        }  

        var start = new Date(sprint.start);
        var finish = new Date(sprint.finish);
        
        var daysInSprint = dateDiffInDays(start, finish);

        var shadow_burndown = {series: burndown.series,
                               labels: [],
                               data: [[]]};

        var current = new Date(start);
        var inADay = new Date();
        var today = new Date();
        var weekend_offset = 0;

        for (var i = 0; i < daysInSprint; i++) {
            current.setTime(start.getTime() + i * _MS_PER_DAY);
            inADay.setTime(current.getTime() + _MS_PER_DAY);

            //TODO create project setting to enable disable weekend burndowns
            if (0 === current.getDay() || 6 === current.getDay()) {
                //skip weekends
                weekend_offset++;
                continue;
            }

            //create x axis
            var dateLabel = current.getDate() + '/' + (current.getMonth()+1);
            shadow_burndown.labels[i - weekend_offset] = dateLabel;

            if (current > today) {
                //just fill in x values from now on
                continue;
            }

            //create y axis
            var todays_hours = 0;
            for (var sprintId = sprint.stories.length - 1; sprintId >= 0; sprintId--) {
                var story = sprint.stories[sprintId];
                
                if (undefined === story.tasks) {
                    continue;
                }                
                for (var taskId = story.tasks.length - 1; taskId >= 0; taskId--) {
                    var task = story.tasks[taskId];
                    var created = new Date(task.created_at);
                    if(created < inADay) {
                        if (task.complete && task.complete_at !== undefined) {
                            //TODO: add label complete_at in [1234-56-78:done]
                            var complete_at = new Date(task.complete_at);
                            if (complete_at < inADay) {
                                continue;
                            }
                        }
                        todays_hours += task.estimatedHours;
                    }                    

                }
            }

            shadow_burndown.data[0][i - weekend_offset] = todays_hours;
        }

        angular.copy(shadow_burndown, burndown);
        console.log(burndown.labels);
        console.log(burndown.data[0]);
    };

    return {
        states: states,
        me: me,
        sprint: sprint,
        columns: columns,
        burndown: burndown,
        working: function() { return workingTasksInProgress > 0; },
        pivoboard_version: pivoboard_version,
        
        clear: clear,
        getMe: getMe,
        getMeBasicAuth: getMeBasicAuth,
        getSprint: getSprint,
        // getStoryTasks: getStoryTasks,
        moveRight: moveRight,
        moveLeft: moveLeft,
        updateTaskOwner: updateTaskOwner,

        saveAccount: saveAccount,
        buyCredits: buyCredits,
        transaction_is_done: transaction_is_done,
        transaction_is_cancelled: transaction_is_cancelled,
        
        activeUsersInProject: activeUsersInProject,
        activeUsersInAccount: activeUsersInAccount,
        currentUserEnabledInAccount: currentUserEnabledInAccount,

        getTransactions: getTransactions,
        isSuperuser: isSuperuser,

        restartUpdatePollTimer: startPollingMe,
        logout: logout
    };
}]);

'use strict';

String.prototype.includes = String.prototype.includes || function(it) {
  return this.indexOf(it) !== -1;
};

angular.module('pivoApp')
.config(["$httpProvider", function($httpProvider) {
    //Enable cross domain calls
    $httpProvider.defaults.useXDomain = true;

    //Remove the header containing XMLHttpRequest used to identify ajax call
    //that would prevent CORS from working
    delete $httpProvider.defaults.headers.common['X-Requested-With'];
}]);



angular.module('pivoApp')
  .controller('MainCtrl', ["$scope", "$window", "$location", "localStorageService", "PivotalService", function ($scope, $window, $location, localStorageService, PivotalService) {
    var settingsInStore = localStorageService.get('settings');
    var DEFAULT_TOKEN = '';

    $scope.settings = settingsInStore || {apiToken: DEFAULT_TOKEN,
                                          accountId: null,
                                          projectId: null,
                                          projectName: 'Project',
                                          username: null};

    $scope.$watch('settings', function () {
      localStorageService.set('settings', $scope.settings);
    }, true);

    if ($scope.settings.username === null &&
        $location.path() !== '/about')
    {
        $location.path('/about');
        $location.replace();
    }

    $scope.columns = PivotalService.columns;
    $scope.sprint = PivotalService.sprint;
    $scope.me = PivotalService.me;
    $scope.working = PivotalService.working;
    $scope.showBurndown = false;

    $scope.reloadPage = function() {
        $window.location.reload();
    };

    $scope.pivoboard_version = PivotalService.pivoboard_version;

    //TODO: move to login ctrl
    $scope.userHasLoggedIn = function() {
        return $scope.me.name;
    };

    var findMyAccount = function() {
        if ($scope.account) { 
            return $scope.account; 
        }

        if ($scope.me.accounts === undefined ||
            $scope.settings === undefined     ||
            $scope.settings.accountId === undefined) {
            return false;
        }

        for (var i = $scope.me.accounts.length - 1; i >= 0; i--) {
            if ($scope.settings.accountId === $scope.me.accounts[i].id) {
                return $scope.me.accounts[i];
            }
        }

        return null;
    };

    $scope.licenseExpired = function(account) {
        account = account || findMyAccount();
        return (account && account.license.state === 'expired');
    };

    $scope.licenseCreditsAreLow = function(account) {
        account = account || findMyAccount();
        return (account && 
                account.license.state === 'licensed' && 
                (account.license.balance < PivotalService.activeUsersInAccount(account))); // jshint ignore:line
    };

    $scope.anyLicensedAccountsOrProjectsWithCurrentUser = function() {
        if ($scope.me.accounts === undefined) {
            return false;
        }

        for (var i = $scope.me.accounts.length - 1; i >= 0; i--) {
            var license = $scope.me.accounts[i].license;
            if (license.state !== 'not_activated') {
                var account = $scope.me.accounts[i];
                if (!account.dirty && PivotalService.currentUserEnabledInAccount(account)) {
                    return true;
                }
            }
        }
        return false;
    };
}])

.controller('BoardCtrl', function () {

})

.controller('FooterController', ['$scope', 'PivotalService', 
function($scope, PivotalService) {
    $scope.pivoboard_version = PivotalService.pivoboard_version;
}])

.directive('testMode', function() {
    var controller = ['$scope', '$http', function($scope, $http) {
	    $scope.enableTestMode = function() {
	        var api = 'api/enable_testmode.php';
			$http.get(api);
	    };
    }];

    return {
        controller: controller,
        restrict: 'E',
        scope: true,
        template: '<button class="btn btn-default"' +
			      '         ng-click="enableTestMode()">' +
			      '      ENABLE TESTMODE' +
			      ' </button>'
    };
})


.directive('columHeading', function() {
    var controller = ['$scope', 'PivotalService', function($scope, PivotalService) {
        $scope.columns = PivotalService.columns;

        $scope.columnHeading = function(column) {
            //css will capitalize for us
            return column.replace('-', ' ');
        };
    }];

    return {
        controller: controller,
        restrict: 'E',
        scope: true,
        templateUrl: 'views/column-heading.html',
    };
})


.directive('story', function() {
    var controller = ['$scope', function($scope) {
        $scope.name = $scope.story.name;
        if ($scope.story.showstory === undefined) {
            $scope.story.showstory = $scope.story.current_state === 'planned'   ||
                                     $scope.story.current_state === 'unstarted' ||
                                     $scope.story.current_state === 'started'   ||
                                     $scope.story.current_state === 'restarted' ||
                                     $scope.story.current_state === 'rejected';
         }

        $scope.storyKindTooltip = function() {
            switch ($scope.story.story_type) {
            case 'bug':
                return 'This story is about a bug';

            case 'chore':
                return 'This story is a chore';

            // case 'feature':
            // case 'release':
            default:
                return 'This is a ' + $scope.story.story_type + ' story';
            }
        };

        // $scope.storyEstimatedHours = function() {
        //     var hours = 0;
        //     if (!$scope.story.tasks) {
        //         return 0;
        //     }

        //     for (var i = $scope.story.tasks.length - 1; i >= 0; i--) {
        //         var task = $scope.story.tasks[i];
        //         var thisHour = task.estimatedHours;
        //         if (!isNaN(thisHour)) {
        //             hours += thisHour;
        //         }
        //     }
        //     return hours;
        // };
    }];

    return {
        controller: controller,
        restrict: 'E',
        scope: true,
        templateUrl: 'views/story.html',
    };
})

.directive('taskcolumn', function() {
    var controller = ['$scope','filterFilter', function($scope, filter) {
        $scope.collapse_override = null;

        $scope.expand = function() {
            $scope.collapse_override = false;
        };

        $scope.collapse = function() {
            $scope.collapse_override = true;
        };

        $scope.isCollapsed = function() {
            if (null === $scope.collapse_override) {
                var column_tasks = filter($scope.story.tasks, {state: $scope.col});
                if (column_tasks && $scope.col === 'done') {
                    return column_tasks.length > 3;
                }
            }
            return $scope.collapse_override;
        };
    }];

    return {
        controller: controller,
        restrict: 'E',
        scope: false,
        template: '<div class="task-col task-col-{{col}}" ng-transclude></div>',
        transclude: true
    };
})

.directive('task', function() {
    var controller = ['$scope', 'PivotalService', function($scope, PivotalService) {
        $scope.taskTitle = function() {
            return $scope.task.title;
        };

        $scope.moveright = function() {
            PivotalService.moveRight($scope.settings, $scope.task);
        };

        $scope.moveleft = function() {
            PivotalService.moveLeft($scope.settings, $scope.task);
        };

        $scope.setOwner = function(owner) {
            owner = owner || '';
            PivotalService.updateTaskOwner($scope.settings, $scope.task, owner);
        };

        $scope.taskIsInMiddleColumns = function() {
            return ($scope.task.state === PivotalService.states.inProgress ||
                    $scope.task.state === PivotalService.states.checkMe);
        };
    }];

    return {
        controller: controller,
        restrict: 'E',
        scope: false,
        templateUrl: 'views/task.html',
    };
});

'use strict';

/**
 * @ngdoc function
 * @name pivoApp.controller:AboutCtrl
 * @description
 * # AboutCtrl
 * Controller of the pivoApp
 */
angular.module('pivoApp')
.controller('AboutCtrl', ["$scope", function ($scope) {
    $scope.myInterval = 6000;
    $scope.slides = [
        {
          image: 'images/scrumboard-online.png',
          caption: 'Scrumboard with stories and tasks in various states'
        },
        {
          image: 'images/pivotal-view.png',
          caption: 'The data is also available in the Pivotal Tracker'
        },
        {
          image: 'images/burndown.png',
          caption: 'A burndown chart is generated'
        },
        {
          image: 'images/licensing.png',
          caption: 'Handle active users and licensing'
        },
        {
          image: 'images/paypal.png',
          caption: 'Buy safely with PayPal'
        }
    ];
}]);

'use strict';

/**
 * @ngdoc function
 * @name pivoApp.controller:AboutCtrl
 * @description
 * # AboutCtrl
 * Controller of the pivoApp
 */
angular.module('pivoApp')
.controller('LicensingCtrl', ['$scope', '$location', '$routeParams', '$timeout', 'PivotalService', '$cookies',
function ($scope, $location, $routeParams, $timeout, PivotalService, $cookies) {
    $scope.save_working = false;
    $scope.buy_working = false;

    $scope.setAccountDirty = function(account, isDirty) {
        account.dirty = isDirty || true;
        PivotalService.restartUpdatePollTimer($scope.settings);
    };

    $scope.letsShowBuyCredits = function(account) {
        $scope.setAccountDirty(account);
        $('#buy-credits-modal-' + account.id).modal('show');
    };

    // var letsHideBuyCredits = function(account) {
    //     $('#buy-credits-modal-' + account.id).modal('hide');
    // };

    $scope.mayAlterLicensing = function(account) {
        return account.admin || account.owner || PivotalService.isSuperuser();
    };

    $scope.mayEnableUser = function(account) {
        if (account.license.state === 'demo') {
            return true;
        }

        if (!$scope.demoLicenseCanBeActivated(account) && $scope.mayAlterLicensing(account)) {
            return (($scope.creditBalance(account) + account.license.used_this_month) > PivotalService.activeUsersInAccount(account)); // jshint ignore:line
        }

        return false;
    };

    $scope.toggleUser = function(account, user) {
        if (!user.active && !$scope.mayEnableUser(account)) {
            return;
        }

        $scope.setAccountDirty(account);

        if ($scope.mayAlterLicensing(account)) {
            console.log('toggle');
            user.active = !user.active;
        }
    };

    $scope.activeUsersViewed = function(project) {
        return PivotalService.activeUsersInProject(project);
    };

    $scope.activeUsersViewedInAccount = function(account) {
        return PivotalService.activeUsersInAccount(account);
    };

    $scope.usedThisMonth = function(account) {
        return Math.max(account.license.used_this_month, // jshint ignore:line
            account.license.state === 'expired' ? 0 : PivotalService.activeUsersInAccount(account));
    };

    $scope.creditBalance = function(account) {
        return Math.max(0,
             Math.min(account.license.balance,
                      account.license.balance - (PivotalService.activeUsersInAccount(account) - account.license.used_this_month))); // jshint ignore:line
    };



    $scope.demoLicenseCanBeActivated = function(account) {
        return account.license.state === 'not_activated';
    };

    $scope.activateDemoLicense = function(account) {
        $scope.setAccountDirty(account);
        account.license.state = 'demo';
        account.license.expiry = 'activate';
    };


    $scope.saveAccount = function(account) {
        if (!account.dirty) {
            console.log('non dirty submit');
            return;
        }

        $scope.save_working = true;
        PivotalService.saveAccount($scope.settings, account)
            .success(function() {
                $scope.setAccountDirty(account, false);
            })
            .success(reloadPage);
    };

    var reloadPage = function() {
            return PivotalService.getMe($scope.settings)
                .success(function() {
                    $scope.save_working = false;
                    $scope.buy_working = false;
                    if ($scope.settings.projectId) {
                        PivotalService.getSprint($scope.settings, 'current');
                    }
                });
    };

    var transaction_reload = function() {
        back_button_used_cancel = null;
        $cookies.remove('buy_in_progress');
        $scope.buy_working = true;
        reloadPage()
        .success(function () {
            $location.url($location.path());
        });
    };

    var poll_transaction = function() {
        console.log('poll');
        PivotalService.transaction_is_done($scope.settings,
                                           $routeParams.account,
                                           $routeParams.transaction)
        .success(transaction_reload)
        .error(function() {
            $timeout(poll_transaction, 2000);
        });
    };

    var cancel_transaction = function (buy_in_progress_data) {
        console.log('transaction is cancelled, cleanup on server');
        buy_in_progress_data = buy_in_progress_data || {account_id: $routeParams.account,
                                                        transaction_id: $routeParams.transaction};

        PivotalService.transaction_is_cancelled($scope.settings,
                                                buy_in_progress_data.account_id,
                                                buy_in_progress_data.transaction_id)
        .success(transaction_reload)
        .error(function() {
            console.error('uups, bad data?');
        });
    };

    $scope.licenseBuyInProgress = function(account) {
        return ($routeParams.account === account.id.toString() &&
                $routeParams.paypal  === 'success');
    };

    $scope.licenseBuyCancelled = function(account) {
        if (back_button_used_cancel === account.id) {
            return true;
        }

        return $routeParams.account === account.id.toString() &&
               $routeParams.paypal  === 'cancel';
    };


    var back_button_used_cancel = null;

    if ($routeParams.paypal  === 'success') {
        $timeout(poll_transaction, 2000);
    }
    else if ($routeParams.paypal  === 'cancel') {
        $timeout(cancel_transaction, 3000);
    }
    else {
        var buy_in_progress = $cookies.getObject('buy_in_progress');
        if (buy_in_progress) {
            back_button_used_cancel = buy_in_progress.account_id;
            $timeout(cancel_transaction, 3000, true, buy_in_progress);
        }
    }

}]);

angular.module('pivoApp')
.controller('LicensingAccountController', ['$scope', 'PivotalService',
function ($scope, PivotalService) {
    $scope.loadingTransactions = false;
    $scope.showTransactions = false;

    $scope.toggleTransactions = function() {
        console.log('toggle transactions: ' + $scope.account.id);

        if ($scope.showTransactions) {
            $scope.showTransactions = false;
            return;
        }

        $scope.loadingTransactions = true;
        PivotalService.getTransactions($scope.settings, $scope.account)
        .success(function() {
            $scope.loadingTransactions = false;
            $scope.showTransactions = true;
        })
        .error(function() {
            $scope.loadingTransactions = false;
            console.error('could not find account');
        });
    };
}]);





'use strict';

angular.module('pivoApp')

.factory('LoginService', [function() {
	var login = {error: false,
                 username: null,
                 password: null};

	return {
		login: login
	};
}])

.directive('login', function() {
    var controller = ['$scope', '$route', '$location', 'LoginService', 'PivotalService',
    function($scope, $route, $location, LoginService, PivotalService) {
	    $scope.login = LoginService.login;

		if ($scope.settings.username) {
			$scope.login.username = $scope.settings.username;
		}

	    // $scope.userHasLoggedIn = function() {
	    //     return $scope.me.name;
	    // };

	    $scope.passwordKeyPress = function(keyEvent) {
	        if (keyEvent.which === 13) {
	            $scope.loginPivo();
	        }
	    };

	    $scope.loginPivo = function() {
	        PivotalService.getMeBasicAuth($scope.settings,
	                                      $scope.login.username,
	                                      $scope.login.password)
	            .success(function() {
	                $scope.settings.username = $scope.login.username;
	                $scope.login.error = false;
	                $scope.login.password = null;

	                if ($scope.settings.projectId) {
	                    PivotalService.getSprint($scope.settings, 'current');
	                }
	            })
	            // TODO .success(set_timeout_for_login_refresh)
	            .error(function() {
	                    $scope.login.password = null;
	                    $scope.login.error = true;
	                });
	    };

	    $scope.loginApiToken = function() {
	        PivotalService.getMe($scope.settings)
	            .success(function() {
	                $scope.login.error = false;
	                
	                if ($scope.anyLicensedAccountsOrProjectsWithCurrentUser()) {
	                    if ($scope.settings.projectId) {
	                        PivotalService.getSprint($scope.settings, 'current');
	                    }
	                } else {
	                    // $location.path('/licensing');
	                }
	            })
	            .error(function() {
	                    $scope.login.error = true;
	                });
	    };

	    //auto login
	    if ($scope.settings.apiToken) {
	        $scope.loginApiToken();
	    } else if ($route.current.loadedTemplateUrl === 'views/main.html') {
	    	$location.path('#/about');
	    }

    }];

    return {
        controller: controller,
        restrict: 'E',
        scope: true,
        templateUrl: 'components/login/login.html',
    };
})

.directive('userInfo', function() {
    var controller = ['$scope', '$location', '$cookies', 'localStorageService', 'LoginService', 'PivotalService',
        function($scope, $location, $cookies, localStorageService, LoginService, PivotalService) {

	    $scope.login = LoginService.login;

	    $scope.logout = function() {
	        PivotalService.clear();
	        angular.copy({}, $scope.settings);
	        $scope.login.password = null;
	        localStorageService.clearAll();
	
	        PivotalService.logout()
		        .success(function() {
			        $location.path('about');
		        });
	    };
    }];

    return {
        restrict: 'E',
        controller: controller,
        scope: true,
        templateUrl: 'components/login/user_info.html',
    };
});

'use strict';

angular.module('pivoApp')
.directive('header', function() {
    var controller = ['$scope', '$location', '$route', 'LoginService', 'PivotalService',
        function($scope, $location, $route, LoginService, PivotalService) {

        $scope.$route = $route;
       
        $scope.showBurndownButton = function() {
            return $location.path() === '/';
        };

        $scope.selectProject = function(accountId, project) {
            $scope.settings.accountId = accountId;    
            $scope.settings.projectId = project.id;    
            $scope.settings.projectName = project.name; 
            PivotalService.getSprint($scope.settings, 'current');
            $location.path('/');
        };
    }];

    return {
        restrict: 'E',
        controller: controller,
        scope: true,
        templateUrl: 'components/header/header.html',
    };
});
'use strict';

angular.module('pivoApp')
.directive('burndown', function() {
    var controller = ['$scope', 'PivotalService', function($scope, PivotalService) {
        $scope.burndown = PivotalService.burndown;

        $scope.onClick = function (points, evt) {
            console.log(points, evt);
        };
    }];

    return {
        restrict: 'E',
        controller: controller,
        scope: true,
        templateUrl: 'components/burndown/burndown.html',
    };
});


'use strict';

angular.module('pivoApp')


.directive('paypal', ['$cookies', function($cookies) {
    var controller = ['$scope', '$location', '$sce', 'PivotalService',
    function($scope, $location, $sce, PivotalService) {

        $scope.testMode = $cookies.get('pivotest');
        var url = $scope.testMode ? 'https://www.sandbox.paypal.com' : 'https://www.paypal.com';

        $scope.url = {submit: $sce.trustAsResourceUrl(url + '/cgi-bin/webscr'),
                      image:  $sce.trustAsResourceUrl(url + '/en_US/i/btn/btn_buynowCC_LG.gif'),
                      dot:    $sce.trustAsResourceUrl(url + '/en_US/i/scr/pixel.gif')};

        // check out using PayPal; for details see:
        // http://www.paypal.com/cgi-bin/webscr?cmd=p/pdn/howto_checkout-outside
        var checkoutPaypal = function(numberToBuy, account_id, transaction_id) {
            // if(!$scope.testMode) {
            //     console.error('not ready to run production yet');
            //     return;
            // }

            function addParamToForm(form, key, value) {
                form.append('<input type="hidden" name="' + key + '" value="' + value + '">');
            }

            function encodeResultUrl(is_success, account_id, transaction_id) {
                var url = $location.absUrl() +
                          '?transaction=' + transaction_id +
                          '&account=' + account_id +
                          '&paypal=';

                if (is_success) {
                    url += 'success';
                } else {
                    url += 'cancel';
                }

                return url;
            }

            // cookies
            $cookies.putObject('buy_in_progress', {account_id: account_id, transaction_id: transaction_id});

            // build form
            var form = $('<form></form>');
            form.attr('action', $scope.url.submit);
            form.attr('method', 'POST');
            form.attr('style', 'display:none;');

            addParamToForm(form, 'cmd', '_s-xclick');
            addParamToForm(form, 'hosted_button_id', $scope.button_id);
            addParamToForm(form, 'quantity',         numberToBuy.toString());
            addParamToForm(form, 'custom',           account_id + ',' + transaction_id);
            addParamToForm(form, 'return',           encodeResultUrl(true,  account_id, transaction_id));
            addParamToForm(form, 'cancel_return',    encodeResultUrl(false, account_id, transaction_id));
            form.append('<input type="image" ' +
                              ' src="' + $scope.url.image + '"' +
                              ' alt="PayPal - The safer, easier way to pay online!">');
            form.append('<input type="image" src="' + $scope.url.dot + '">');
            
            $('body').append(form);

            // submit form
            form.submit();
            form.remove();
        };

        $scope.buyCredits = function(account, numberToBuy) {
            $scope.buy_working = true;

            PivotalService.buyCredits($scope.settings, account, numberToBuy)
            .success(function(data) {
                console.log(data);
                checkoutPaypal(numberToBuy, account.id, data.transaction_id);
            });
        };
    }];

    return {
        controller: controller,
        restrict: 'E',
        scope: true,
        templateUrl: 'components/paypal/pay_now.html',
        link: function(scope, element, attributes) {

            attributes.$observe('location', function(value) {
                console.log(value);
                var testMode = $cookies.get('pivotest');

                switch(value) {
                    case 'sweden':
                        scope.button_id = testMode ? '2JG4VH8DAZNEC' : 'WCTQP58Y7VJTW';
                        break;

                    case 'europe':
                        scope.button_id = testMode ? 'YQW4YVJFBGY9Y' : 'VBVVRAHD2MEJA';
                        break;

                    case 'export':
                        scope.button_id = testMode ? '8S8HUW7RPWXCW' : '7LN5CHAJANY4N';
                        break;

                    default:
                        scope.buyerLocation = null;
                        return;
                }
                scope.buyerLocation = value;
            });

            attributes.$observe('quantity', function(value) {
                console.log(value);
                scope.quantity = value;
            });
        }
    };
}]);


'use strict';

angular.module('pivoApp')


.directive('buyCreditsModal', function() {
    var controller = ['$scope', 'PivotalService',
    function($scope, PivotalService) {
    	$scope.account = $scope.$parent.account;
	    $scope.minimumNumberOfUsers = 5;
	    $scope.numberToBuy = 3;
	    $scope.readLicenseAgreement = false;
	    $scope.costPerUserAndProject = 42;
	    $scope.costCurrency = 'SEK';
	    $scope.buyCreditsUnit = 'months';

	    if (!$scope.account.settings.company.location) {
	    	$scope.account.settings.company.location = angular.copy('sweden');
	    }


	    $scope.calculateLicenseCost = function(account, numCredits) {
	        return $scope.costPerUserAndProject * numCredits;
	    };


	    $scope.calculateNumCreditsToBuy = function(account, num, unit) {
	        if (unit === 'months') {
	            return num * PivotalService.activeUsersInAccount(account);
	        }
	        else {
	            return num;   
	        }
	    };


	    $scope.updateLocation = function(account) {
	        var location = account.settings.company.location;
	        console.log('updateLocation: ' + location);
	        switch(location) {
	            case 'sweden':
	                $scope.costCurrency = 'SEK';
	                $scope.costPerUserAndProject = 42;
	                break;

	            case 'europe':
	                $scope.costCurrency = '€';
	                $scope.costPerUserAndProject = 4.5;
	                break;

	            case 'export':
	                $scope.costCurrency = '$';
	                $scope.costPerUserAndProject = 5;
	                break;
	        }
	    };


	    $scope.buyButtonDisabled = function(account) {
	        var a = $scope.readLicenseAgreement;
	        var b = account.settings.company.location;
	        var c = $scope.calculateNumCreditsToBuy(account,
	                                                $scope.numberToBuy,
	                                                $scope.buyCreditsUnit);
	        var d = $scope.form_company_info.$valid;
	        //console.log('buyButtDis:' + a + ' ' + b + ' ' + c + ' ' + d);
	        return (!a || !b || !c || !d);
	    };
    
    	$scope.buyButtonTooltip = function(account) {
    		return $scope.buyButtonDisabled(account) ? 
    			'Please fill in all fields before proceeding to paypal' :
    			'Proceed to Paypal';
    	};
    }];


    return {
        controller: controller,
        restrict: 'E',
        scope: true,
        templateUrl: 'components/buy_credits/view.html',
        // link: function(scope, element, attributes) {

        //     // scope.$watch('account', function(value) {
        //     //     scope.account = value;
        //     // });
        // }
    };
});

'use strict';

angular.module('pivoApp')

.directive('transactionHeading', [function() {
    return {
        restrict: 'E',
        templateUrl: 'components/transaction/heading_view.html',
    };
}])

.directive('transaction', [function() {
    var controller = ['$scope',
    function($scope) {
		$scope.transaction = $scope.$parent.transaction;

		$scope.show = function() {
			switch ($scope.transaction.type) {
			case 'PivoLogCredits':
				switch ($scope.transaction.reason) {
				case 'prepare_to_buy_credits':
					return false;
				}
			}			

			return true;
		};

		$scope.timestamp = function() {
			return $scope.transaction.timestamp;
		}; 	

		$scope.description = function() {
			switch ($scope.transaction.type) {
			case 'PivoLogLicenseTransition':
				switch ($scope.transaction.new_state) {
				case 'demo':
					return 'Demo license activated';

				case 'licensed':
					return 'License activated';

				case 'expired':
					return 'License expired';

				default:
					return 'License';
				}
				break;

			case 'PivoLogActiveUsers':
				return 'User configuration changed'; //TODO: +' for project NNN'

			case 'PivoLogCredits':
				switch ($scope.transaction.reason) {
				case 'buy':
					return 'Bought credits';
				
				case 'new month': 
					return 'New month started';

				default:
					return $scope.transaction.reason;
				}
			}
		};

		$scope.diff = function() {
			return $scope.transaction.credit_diff || '-';
		};

		$scope.balance = function() {
			return $scope.transaction.credit_balance_after || '-';
		}; 	
    }];

    return {
        controller: controller,
        restrict: 'E',
        scope: true,
        templateUrl: 'components/transaction/main_view.html',
        // link: function(scope, element, attributes) {
        //     attributes.$observe('transaction', function(value) {
        //         console.log(value);
        //         scope.transaction = value;
        //     });
        // }
    };
}]);

'use strict';

angular.module('pivoApp')


.directive('licensingAccountPopups', [function() {
    var controller = ['$scope',
    function($scope) {
        $scope.account = $scope.$parent.account;

    }];

    return {
        controller: controller,
        restrict: 'E',
        scope: true,
        templateUrl: 'components/licensing/account.html',
        // link: function(scope, element, attributes) {
        //     attributes.$observe('transaction', function(value) {
        //         console.log(value);
        //         scope.transaction = value;
        //     });
        // }
    };
}]);

//# sourceMappingURL=scripts.js.map